import { useState, useEffect } from 'react';

interface User {
  id: number;
  nickName: string;
  email: string;
  password_hash?: string;
  google_id?: string;
  name?: string;
  resetPasswordToken?: string;
  resetPasswordExpires?: Date;
  verified?: boolean;
  createdAt?: Date;
  updatedAt?: Date;
  role?: string;
  status?: 'Active' | 'Inactive';
  walletAddress?: string;
}

interface EditUserModalProps {
  isOpen: boolean;
  onClose: () => void;
  user: User;
  onSave: (id: number, updatedUser: User) => void;
}

const EditUserModal = ({ isOpen, onClose, user, onSave }: EditUserModalProps) => {
  const [editedUser, setEditedUser] = useState<User>(user);

  useEffect(() => {
    setEditedUser(user);
  }, [user]);

  if (!isOpen) return null;

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    const { name, value } = e.target;
    setEditedUser({ ...editedUser, [name]: value });
  };

  const handleSubmit = () => {
    onSave(editedUser.id, editedUser);
    onClose();
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
      <div className="gothic-panel w-full max-w-md">
        <h2 className="gothic-heading text-2xl mb-4">Edit User</h2>
        <div className="mb-4">
          <label className="block gothic-text-silver text-sm font-bold mb-2" htmlFor="name">
            Username:
          </label>
          <input
            type="text"
            id="name"
            name="name"
            value={editedUser.name || ''}
            onChange={handleChange}
            className="gothic-input"
          />
        </div>
        <div className="mb-4">
          <label className="block gothic-text-silver text-sm font-bold mb-2" htmlFor="email">
            Email:
          </label>
          <input
            type="email"
            id="email"
            name="email"
            value={editedUser.email || ''}
            onChange={handleChange}
            className="gothic-input"
          />
        </div>
        <div className="mb-4">
          <label className="block gothic-text-silver text-sm font-bold mb-2" htmlFor="role">
            Role:
          </label>
          <input
            type="text"
            id="role"
            name="role"
            value={editedUser.role || ''}
            onChange={handleChange}
            className="gothic-input"
          />
        </div>
        <div className="mb-6">
          <label className="block gothic-text-silver text-sm font-bold mb-2" htmlFor="status">
            Status:
          </label>
          <select
            id="status"
            name="status"
            value={editedUser.status || 'Active'}
            onChange={handleChange}
            className="gothic-input"
          >
            <option value="Active">Active</option>
            <option value="Inactive">Inactive</option>
          </select>
        </div>
        <div className="mb-6">
          <label className="block gothic-text-silver text-sm font-bold mb-2" htmlFor="password">
            Password (leave blank to keep current):
          </label>
          <input
            type="password"
            id="password"
            name="password"
            value={editedUser.password_hash || ''}
            onChange={handleChange}
            className="gothic-input"
          />
        </div>
        <div className="mb-4">
          <label className="block gothic-text-silver text-sm font-bold mb-2" htmlFor="walletAddress">
            Wallet Address:
          </label>
          <input
            type="text"
            id="walletAddress"
            name="walletAddress"
            value={editedUser.walletAddress || ''}
            onChange={handleChange}
            className="gothic-input"
          />
        </div>
        <div className="flex items-center justify-end">
          <button
            onClick={onClose}
            className="gothic-button gothic-button-error mr-2"
          >
            Cancel
          </button>
          <button
            onClick={handleSubmit}
            className="gothic-button gothic-button-primary"
          >
            Save Changes
          </button>
        </div>
      </div>
    </div>
  );
};

export default EditUserModal;